import React from 'react';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import Platform from "react-native-web/dist/exports/Platform";
import PropTypes from 'prop-types';
import { useThemeTokens, applyOuterBorder } from '../ThemeProvider';
import { a11yProps, getTokensPropType, selectSystemProps, variantProp, viewProps } from '../utils';
import Icon from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([a11yProps, viewProps]);
const selectInnerContainerStyles = _ref => {
  let {
    borderRadius,
    width,
    backgroundColor
  } = _ref;
  return {
    borderRadius,
    width,
    backgroundColor
  };
};
const selectIconTokens = _ref2 => {
  let {
    iconSize,
    iconColor,
    iconScale = 1
  } = _ref2;
  return {
    size: iconSize,
    color: iconColor,
    scale: iconScale
  };
};

/**
 * `TooltipButton` is a helper component used as a default control for the `Tooltip` component.
 * In fact though, it isn't actually a pressable - it's meant to be used as pressable's content.
 * Due to this any interaction states (e.g. pressed, hover, etc.) has to be passed down to it as a prop.
 */
const TooltipButton = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    pressableState,
    tokens,
    variant,
    ...rest
  } = _ref3;
  const themeTokens = useThemeTokens('TooltipButton', tokens, variant, pressableState);
  const {
    icon: IconComponent
  } = themeTokens;
  return /*#__PURE__*/_jsx(View, {
    style: [applyOuterBorder(themeTokens), themeTokens.outerBorderWidth && {
      margin: -themeTokens.outerBorderWidth
    }, staticStyles.bubblePointerEvents],
    ...selectProps(rest),
    ref: ref,
    children: /*#__PURE__*/_jsx(View, {
      style: selectInnerContainerStyles(themeTokens),
      children: IconComponent && /*#__PURE__*/_jsx(Icon, {
        icon: IconComponent,
        tokens: selectIconTokens(themeTokens)
      })
    })
  });
});
TooltipButton.displayName = 'TooltipButton';
const staticStyles = StyleSheet.create({
  bubblePointerEvents: {
    ...Platform.select({
      web: {
        pointerEvents: 'none'
      }
    })
  }
});
TooltipButton.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Used as appearances when resolving theme tokens.
   */
  pressableState: PropTypes.shape({
    pressed: PropTypes.bool,
    hover: PropTypes.bool,
    focus: PropTypes.bool
  }),
  tokens: getTokensPropType('TooltipButton'),
  variant: variantProp.propType
};
export default TooltipButton;